<template>
  <div class="review-login">
    <div class="review-login_container">
      <van-field label-width="60" v-model="username" label="用户名" />
      <van-field label-width="60" v-model="phoneNum" type="digit" label="手机号" />
      <van-checkbox v-model="saveLogin" shape="square">记住登录信息</van-checkbox>
      <van-button class="login_submit" @click="submit">登录</van-button>
    </div>
  </div>
</template>

<script>
import { Toast, ImagePreview, Overlay } from 'vant';
import jsCookies from 'js-cookie'
import {
  appraiserLogin
} from "@/common/api/appraisal.js";
let toPath;
export default {
  mounted () {
    console.log(localStorage.getItem('info'));
    if (localStorage.getItem('info')) {
      let info = JSON.parse(localStorage.getItem('info'))
      this.saveLogin = info.saveLogin
      this.username = info.username
      this.phoneNum = info.phoneNum
    }
  },
  data () {
    return {
      username: '',
      phoneNum: '',
      saveLogin: '',
    }
  },
  beforeRouteEnter(to, from, next) {
    console.log(from);
    toPath = from.path
    next(); // 必需调用
  },
  methods: {
    async submit () {
      const { username, phoneNum, saveLogin } = this
      
      if (!username) {
        Toast('请输入用户名')
        return
      }
      if (!phoneNum) {
        Toast('请输入手机号')
        return
      }
      if (!/^1[3456789]\d{9}$/.test(phoneNum)) {
        Toast('请输入正确的手机号')
        return
      }
      let info = {
        username,
        phoneNum,
        saveLogin
      }
      if (saveLogin) {
        if (localStorage.getItem('info')) {
          localStorage.removeItem('info')
        }
        localStorage.setItem("info", JSON.stringify(info));
      } else {
        localStorage.removeItem("info"); 
      }
      await appraiserLogin({
        appraiserName: username,
        appraiserPhone: phoneNum,
      }).then(res => {
        if (res.errorCode === 0) {
          Toast('登录成功')
          console.log(res.token);
          jsCookies.set('reviewToken', res.token)
          this.$router.push({
            path:toPath,
            query: {
              isFirstLogin: '1'
            }
          })
        } else {
          Toast(res.msg)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.review-login {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  .review-login_container {
    width: 80%;
    height: 450px;
    background-color: #Fff;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
}
</style>